import { useRef, useEffect } from 'react';
import { useTranslation } from '@tasama/i18n';
import { useUserContextStore } from '../stores/user-context.store';
import { useAuthStore } from '../stores/auth-store';

export function useAnalyticsIdentity(): void {
  const fired = useRef(false);
  const userContext = useUserContextStore((state) => state.userContext);
  const user = useAuthStore((state) => state.user);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (
      fired.current ||
      !userContext ||
      !user ||
      typeof window.gtag !== 'function'
    )
      return;
    fired.current = true;
    window.gtag('set', { user_id: user.id });
    window.gtag('set', 'user_properties', {
      company_type: userContext.companyType?.toLowerCase(),
      language: i18n.resolvedLanguage,
    });
  }, [userContext, user, i18n.resolvedLanguage]);
}
